import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { isGiftListSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/button';
import { SectionContainer } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/section-container';
import {
  BodyText,
  Header2,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/typography';
import { useWeddingWebsiteData } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/data/data-context';

export const GiftList = () => {
  const { t } = useTranslation('weddingWebsite');
  const { website, isGuestView } = useWeddingWebsiteData();
  const section = website.sections.find(isGiftListSection);
  const dispatch = useDispatch();

  const hasUrl = !!section?.data.url && section?.data.url !== '';

  const handleClick = useCallback(() => {
    if (isGuestView) {
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'weddingWebsites',
          clickedSection: 'giftList',
          cta: 'View our gift list',
          trackingTarget: 'BigQuery',
        }),
      );
    }
  }, [dispatch, isGuestView]);

  return (
    <SectionContainer detailsSectionId="giftList" previewSectionId="giftList">
      <Header2>{t('previewMode.tile.giftList.title')}</Header2>
      <BodyText>{section?.data.message}</BodyText>
      <Button asChild={hasUrl} onClick={handleClick}>
        {hasUrl ? (
          <a href={section?.data.url} target="_blank" rel="noreferrer">
            {t('previewMode.tile.giftList.viewGiftList')}
          </a>
        ) : (
          t('previewMode.tile.giftList.viewGiftList')
        )}
      </Button>
    </SectionContainer>
  );
};
